import { useCallback, useRef, useState } from "react";
import { playVoice, stopVoice } from "./voice";

const clean = (t) => t.replace(/\[\[REPARTO:[^\]]+\]\]/g, "").trim();

export function useNarrator(setSubtitle, defaultOn = true) {
  const [voiceOn, setVoiceOn] = useState(defaultOn);
  const voiceRef = useRef(defaultOn);
  const timer = useRef(null);
  const token = useRef(0);

  const stop = useCallback(() => {
    token.current += 1;
    clearTimeout(timer.current);
    stopVoice();
    setSubtitle("");
  }, [setSubtitle]);

  const narrate = useCallback((raw, onDone) => {
    stop();
    const text = clean(raw);
    const my = token.current;
    let finished = false;
    const done = () => {
      if (finished || my !== token.current) return;
      finished = true;
      clearTimeout(timer.current);
      setSubtitle("");
      onDone?.();
    };
    setSubtitle(text);
    const estimate = text.split(/\s+/).length * 430 + 1500;
    if (voiceRef.current) {
      timer.current = setTimeout(done, estimate + 15000);
      playVoice(text, (ok) => {
        if (my !== token.current) return;
        clearTimeout(timer.current);
        if (ok) done();
        else timer.current = setTimeout(done, estimate);
      });
    } else {
      timer.current = setTimeout(done, estimate);
    }
  }, [setSubtitle, stop]);

  const toggleVoice = useCallback(() => {
    voiceRef.current = !voiceRef.current;
    setVoiceOn(voiceRef.current);
    if (!voiceRef.current) stopVoice();
  }, []);

  return { narrate, stop, voiceOn, toggleVoice };
}
